import { useComputedCallback } from '../utils/useComputedCallback';
import { useBlocker } from './useBlocker';
export const usePrompt = (messageValue, whenValue = true) => {
    const message = useComputedCallback(messageValue);
    useBlocker((tx) => {
        if (window.confirm(message.value)) {
            tx.retry();
        }
    }, whenValue);
};
